import { combineReducers } from 'redux';
import {
    HIDE_ERROR_NOTIFICATION,
    OPEN_CLOSE_ANIMATED_DRAWER,
    SET_FILTER_TYPE_TO_SHOW,
    SET_HOVER_EVENT_TARGET,
    SHOW_ERROR_NOTIFICATION,
} from '../actions/ui';

const isAnimatedDrawerOpen = (
    state = false,
    { type, payload }: { type: string; payload?: any },
) => {
    let nextState = state;

    if (type === OPEN_CLOSE_ANIMATED_DRAWER) {
        nextState = payload.open;
    }

    return nextState;
};

const filterTypeToShow = (
    state = '',
    { type, payload }: { type: string; payload?: any },
) => {
    let nextState = state;

    if (type === OPEN_CLOSE_ANIMATED_DRAWER) {
        nextState = payload.filterType || '';
    } else if (type === SET_FILTER_TYPE_TO_SHOW) {
        nextState = payload;
    }

    return nextState;
};

const eventHoverTarget = (
    state = null,
    { type, payload }: { type: string; payload?: any },
) => {
    let nextState = state;

    if (type === SET_HOVER_EVENT_TARGET) {
        nextState = payload;
    }

    return nextState;
};

const showErrorNotification = (
    state = false,
    { type, payload }: { type: string; payload?: any },
) => {
    let nextState = state;

    if (type === SHOW_ERROR_NOTIFICATION) {
        nextState = payload;
    } else if (type === HIDE_ERROR_NOTIFICATION) {
        nextState = false;
    }

    return nextState;
};

export default combineReducers({
    eventHoverTarget,
    isAnimatedDrawerOpen,
    filterTypeToShow,
    showErrorNotification,
});
